import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaEye, FaEyeSlash } from "react-icons/fa"; 
import { CrewStyle, EnterButton, LoginCrewCard, LoginField, SesiImage, StaticImage, WrapContent, WrapContentLoginCrewCard } from "../../styles/CrewLogin";
import BACKGROUNDIMAGE from "../../assets/img/backgroundImage.png";
import SESI from "../../assets/img/sesi.png";
import { CREW_PAGE } from "../../core/app-urls";
import { crewAuth } from "../../data/services/crew_service";

export default function CrewLogin() {
  const [user, setUser] = useState<string>("");
  const [password, setPassword] = useState<string>("");
  const [error, setError] = useState<string | null>(null);
  const [showPassword, setShowPassword] = useState<boolean>(false); 
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem("access_token");
    if (token) {
      navigate(CREW_PAGE);
    }
  }, [navigate]);

  const handleClickEnterButton = async () => {
    setError(null);
    try {
      await crewAuth(user, password);
      navigate(CREW_PAGE);
    } catch (err) {
      setError("Login ou senha inválidos. Tente novamente.");
    }
  };

  const toggleShowPassword = () => {
    setShowPassword((prevState) => !prevState);
  };

  return (
    <CrewStyle>
      <WrapContent>
        <SesiImage src={SESI} />
        <h1>PORTAL DO CLIENTE</h1>
        <h3>EQUIPE SESI</h3>
        <LoginCrewCard>
          <WrapContentLoginCrewCard>
            <LoginField 
              placeholder="Login" 
              value={user} 
              onChange={(e) => setUser(e.target.value)} 
            />
            <div style={{ position: "relative" }}>
              <LoginField 
                placeholder="Senha" 
                type={showPassword ? "text" : "password"} 
                value={password} 
                onChange={(e) => setPassword(e.target.value)} 
              />
              <button 
                onClick={toggleShowPassword} 
                style={{
                  position: "absolute",
                  right: "10px",
                  top: "42%",
                  transform: "translateY(-50%)",
                  background: "none",
                  border: "none",
                  cursor: "pointer",
                  color: "#888",
                  fontSize: "20px"
                }}
              >
                {showPassword ? <FaEyeSlash /> : <FaEye />}
              </button>
            </div>
            {/* <a href="#">Esqueci minha senha</a> */}
            <EnterButton onClick={handleClickEnterButton}>Entrar</EnterButton>
            {error && <p style={{ color: "red", marginTop: "10px" }}>{error}</p>}
          </WrapContentLoginCrewCard>
        </LoginCrewCard>
        <h2>Developed by WBC SISTEMAS</h2>
        <StaticImage src={BACKGROUNDIMAGE} />
      </WrapContent>
    </CrewStyle>
  );
}
